<!--
  @description 关机申请单
  @author xiehan
  @date 2019/01/17
-->
<template>
    <div class="shutdownOrder">
      <request-note
        ref="requestNote"
        @submitRequest="getRequestForm"
        submitButtonRac="shutdownOrder@submit"
        :requestTitle="$t('cloudApplication.shutdownRequest')"
        :assignee="assignee"
        :status="status"
        :requestInfo="requestInfo">
        <div slot="center">
          <el-table
            :data="tableData"
            border
            style="width: 100%;">
            <el-table-column
              prop="ip"
              label="IP">
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer">
          <el-form label-width="80px" v-if="!assignee && (status !== '6' && status !== '5')">
            <el-form-item :label="$t('cloudApplication.currentAssignee')">
              <span v-text="requestInfo.currentAssignee"></span>
            </el-form-item>
          </el-form>
          <el-table
            v-if="!assignee"
            :data="processTable"
            style="width: 100%">
            <el-table-column prop="operateTime" :label="$t('common.time')"></el-table-column>
            <el-table-column prop="node" :label="$t('queryworkOrder.node')"></el-table-column>
            <el-table-column prop="operator" :label="$t('queryworkOrder.operator')"></el-table-column>
            <el-table-column prop="operation" :label="$t('common.handle')"></el-table-column>
            <el-table-column prop="advise" :label="$t('queryworkOrder.advise')"></el-table-column>
          </el-table>
        </div>
      </request-note>
    </div>
  </template>
  
  <script>
    import dic from '@/components/mixins/dic'
    import requestNote from '@/views/component/requestNote/requestNote'
    import queryworkOrderBiz from '@/logic/workFlow/queryworkOrderBiz'
    import TimeFormat from '@/utils/timeFormat'
    export default {
      mixins: [dic],
      data () {
        return {
          status: '',
          select_site: {},
          select_operate: {},
          requestInfo: {},
          assignee: true,
          processTable: [],
          tableData: []
        }
      },
      components: {
        requestNote
      },
      methods: {
        init () {
          this.status = String(this.$route.query.status)
          this.assignee = String(this.$route.query.assignee) === '1'
          this.getDic()
        },
        getOrderInfoById () {
          queryworkOrderBiz.getTaskDetailById({
            processInstanceId: String(this.$route.query.orderId)
          }).then(data => {
            this.requestInfo = data.info
            this.requestInfo.site = this.select_site[this.requestInfo.site]
            this.requestInfo.date = TimeFormat.getFormatTime(this.requestInfo.date)
            this.requestInfo.expectedTime = TimeFormat.getFormatTime(this.requestInfo.expectedTime)
            this.processTable = data.record
            this.processTable.map(item => {
              item.operateTime = TimeFormat.getFormatTime(item.operateTime)
              item.operation = this.select_operate[item.operation]
            })
            this.tableData = []
            this.requestInfo.ipList.map(item => {
              this.tableData.push({ ip: item })
            })
          })
        },
        async getDic () {
          await Promise.all([
            this.dGetDictionaryByCode('remoteconfig'),
            this.dGetDictionaryByCode('workflowOperationType')
          ])
          this.select_site = { ...this.dDictionary.remoteconfig }
          this.select_operate = { ...this.dDictionary.workflowOperationType }
          this.getOrderInfoById()
        },
        getRequestForm (val) {
          let eventName
          let param = {}
          if (this.$route.query.status === '2') {
            eventName = 'shutdownApproveApply'
            param = { ...val }
          } else if (this.$route.query.status === '3') {
            eventName = 'shutdownExecute'
          }
          queryworkOrderBiz[eventName]({
            processInstanceId: this.$route.query.orderId, ...param
          }).then(data => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.$router.push({ name: 'queryworkOrder' })
          })
        }
      },
      watch: {
        $route (to, from) {
          if (to.name === 'shutdownOrder' && from.name === 'queryworkOrder') {
            if (this.status === '5') {
              this.$nextTick(() => {
                this.$refs.requestNote.onStatus5()
              })
            } else {
              this.$refs.requestNote.init()
            }
            this.init()
          }
        }
      },
      mounted () {
        this.init()
        if (this.status === '5') {
          this.$nextTick(() => {
            this.$refs.requestNote.onStatus5()
          })
        }
      }
    }
  </script>
  
  <style scoped>

  </style>